import { createContext } from "react";

// The height (CSS px) the in-game scoreboard may take on the compact layout,
// measured by GameLayout from the room the board panel has (above the arena
// upright, beside it sideways). Score shows as many rows as fit in it, with
// your own row always among them. null: no budget, every row shows.
export const ScoreFitContext = createContext<number | null>(null);

// The roomy layout for a wide map (the 2:1 rectangle or stadium on a computer)
// has no side rail: the scoreboard runs along the bottom as slanted "racing
// stripe" cards instead of rows (Score.tsx). GameLayout sets it.
export const ScoreStripesContext = createContext<boolean>(false);
// Set where a wide map on a computer keeps its scoreboard (under the board,
// GameLayout): a GameHud rendered there draws only a duel's big best-of marks
// (nothing for any other match), and the player rows beside it hide.
export const HudBoardContext = createContext<boolean>(false);
